import {
	Tooltip,
	Box,
	FormControl,
	InputLabel,
	OutlinedInput,
	InputAdornment,
} from "@mui/material";
import type { KeyboardEventHandler } from "react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

type Props = {
	onKeyDown: KeyboardEventHandler<HTMLInputElement> | undefined;
};

export const SearchFilter = ({ onKeyDown }: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const search = searchParams.get("search") ?? "";
	const [localValue, setLocalValue] = useState(search);

	// Debounce the search parameter update
	useEffect(() => {
		const timeoutId = setTimeout(() => {
			if (localValue !== search) {
				if (localValue === "") {
					searchParams.delete("search");
				} else {
					searchParams.set("search", localValue);
				}
				setSearchParams(searchParams, { replace: true });
			}
		}, 500);

		return () => clearTimeout(timeoutId);
	}, [localValue, search, searchParams, setSearchParams]);

	// Update local value when search params change externally
	useEffect(() => {
		setLocalValue(search);
	}, [search]);

	const handleFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
		setLocalValue(e.target.value);
	};

	return (
		<Tooltip
			title="Search within the last 20 work orders for this asset"
			placement="top"
		>
			<Box
				sx={{
					"& .MuiOutlinedInput-input": {
						backgroundColor: "#FFFF",
						paddingTop: "6px",
						paddingBottom: "6px",
					},
				}}
			>
				<FormControl variant="outlined" size="small" sx={{ width: "100%" }}>
					<InputLabel id="search-label">Search</InputLabel>
					<OutlinedInput
						id="search-input"
						label="Search"
						placeholder="Search last 20 orders..."
						onKeyDown={onKeyDown}
						value={localValue}
						onChange={handleFilter}
						autoComplete="off"
						endAdornment={
							<InputAdornment position="end">
								<Box
									component="i"
									className="fa fa-search"
									sx={{ cursor: "pointer" }}
								/>
							</InputAdornment>
						}
					/>
				</FormControl>
			</Box>
		</Tooltip>
	);
};
